import React from "react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import { references } from "../mock";

export default function References() {
  return (
    <div className="bg-white" data-testid="references-page">
      <PageBanner
        title="Referanslarımız"
        subtitle="Yılların tecrübesiyle birçok değerli kurumun projelerinde çözüm ortağı olduk."
        breadcrumbs={[{ label: "Referanslarımız" }]}
        image="/images/slider/slider4.jpg"
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <SectionHeading align="center" eyebrow="Güven" title="Bize Güvenen Kurumlar" className="mb-16" />
          </Reveal>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-brand-line border border-brand-line">
            {references.map((r, i) => (
              <Reveal key={r.id} delay={(i % 5) * 60}>
                <div
                  data-testid={`reference-logo-${r.id}`}
                  className="group bg-white h-32 flex items-center justify-center px-8 hover:bg-brand-paper transition-colors duration-500"
                >
                  <img
                    src={r.image}
                    alt={`Referans ${r.id}`}
                    loading="lazy"
                    className="max-h-12 max-w-full object-contain grayscale opacity-45 group-hover:grayscale-0 group-hover:opacity-100 transition-[opacity,filter] duration-500"
                  />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <QuoteBand />
    </div>
  );
}
